import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { VoteStatus } from "../Deliberation/useVoteState";
import ValidateButton from "../common/Buttons/ValidateButton";

type Props = {
    voteStatus: VoteStatus;
    remainingWeight?: number;
    validateVote: () => void;
    resetVote: () => void;
    canAnswerBeUpdated: boolean;
};

const ActionSection = ({
    voteStatus,
    validateVote,
    resetVote,
    remainingWeight = 0,
    canAnswerBeUpdated,
}: Props) => {
    const { t } = useTranslation();

    const renderInformationMessage = () => {
        switch (voteStatus) {
            case VoteStatus.Incomplete:
                return (
                    <p>
                        {t(`errorVoteIncomplete.${window.env.REACT_APP_THEME}`)}
                    </p>
                );
            case VoteStatus.Success:
                return <p>{t(`sentSucceded.${window.env.REACT_APP_THEME}`)}</p>;
            case VoteStatus.Loading:
                return <p>...{t("loading")}</p>;
            case VoteStatus.PendingValidation:
                return (
                    <p>
                        {t(`answerNotValidated.${window.env.REACT_APP_THEME}`)}
                    </p>
                );
            case VoteStatus.Error:
                return <p>{t("errorUnknown")}</p>;
        }
    };

    const shouldDisplayButton: boolean =
        voteStatus !== VoteStatus.Success || canAnswerBeUpdated;

    return (
        <Wrapper>
            {VoteStatus.Idle === voteStatus ? (
                <div style={{ height: "30px" }}></div>
            ) : (
                <StyledMessage
                    data-testid="message-distribution"
                    color={
                        VoteStatus.Success === voteStatus ? "#60b860" : "red"
                    }
                >
                    <div>{renderInformationMessage()}</div>
                </StyledMessage>
            )}
            {shouldDisplayButton && (
                <ValidateButton
                    isDisabled={
                        VoteStatus.Idle === voteStatus ||
                        VoteStatus.Incomplete === voteStatus ||
                        VoteStatus.NotAllowed === voteStatus ||
                        VoteStatus.Loading === voteStatus ||
                        remainingWeight !== 0
                    }
                    onClick={
                        VoteStatus.Success === voteStatus
                            ? resetVote
                            : validateVote
                    }
                    text={
                        VoteStatus.Success === voteStatus
                            ? t(`changeAnswer.${window.env.REACT_APP_THEME}`)
                            : t(`validateAnswer.${window.env.REACT_APP_THEME}`)
                    }
                />
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin-top: 1rem;
`;

const StyledMessage = styled.div`
    color: ${(props) => props.color};
    width: 100%;
    text-align: center;
`;

export default ActionSection;
